module.exports = __webpack_public_path__ + "99e06b5260094b26ffa374ec183de095.svg";